import { createStore, createEvent } from "effector"
import { without } from "lodash"

const addZIndex = createEvent<number>()
const removeZIndex = createEvent<number>()

const zIndexes = createStore<number[]>([])

zIndexes.on(addZIndex,
    (state: number[], zIndex: number) => {
        return [...state, zIndex]
    }
)

zIndexes.on(removeZIndex,
    (state: number[], zIndex: number) => {
        return without(state, zIndex)
    }
)

export default {
    addZIndex,
    removeZIndex,
    zIndexes
}
